/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserRoleInput = {
    /**
     * Unique ID of the user.
     */
    userID: string;
    /**
     * Role of the user.
     */
    role: UserRoleInput.role;
    /**
     * Unique ID of the company the user works for.
     */
    companyID?: string;
    /**
     * Unique ID of the store the user works at.
     */
    storeID?: string;
};
export namespace UserRoleInput {
    /**
     * Role of the user.
     */
    export enum role {
        BASIC = 'BASIC',
        COMPANY_EMPLOYEE = 'COMPANY_EMPLOYEE',
        MEDICAL_DOCTOR = 'MEDICAL_DOCTOR',
        SITE_ADMIN = 'SITE_ADMIN',
        COMPANY_ADMIN = 'COMPANY_ADMIN',
        SUPER_ADMIN = 'SUPER_ADMIN',
        SUPPORT_ADMIN = 'SUPPORT_ADMIN',
    }
}

